import { procurementAPI } from "../../axios";

export const actions = {

    GetRfqActivity(context, data){
        return procurementAPI.get(`RfqActivity/Rfq/${data}`);
    },
    GetSingleRfqActivity(context, data){
        return procurementAPI.get(`RfqActivity/${data}`);
    },
    CreateRfqActivity(context, data){
        return procurementAPI.post(`RfqActivity`, data);
    },
    UpdateRfqActivity(context, data){
        return procurementAPI.put(`RfqActivity/Update/${data.id}`, data);
    },
    DeleteRfqActivity(context, data){
        return procurementAPI.delete(`RfqActivity/Delete/${data}`);
    }
}